export var TYPES = {
  COMPACT: 'compact',
  WIDER: 'wider'
};